import { render, staticRenderFns } from "./TaModuleCard.vue?vue&type=template&id=0e6bdcae&scoped=true&"
import script from "./TaModuleCard.vue?vue&type=script&lang=js&"
export * from "./TaModuleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6bdcae",
  null
  
)

export default component.exports